import { videoViewsCompleteConfig } from '../videoViewsComplete';
import { SIZE_FULL } from '@/lib/gridElements/size';
import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const videoViewsCompleteMVConfig = {
    ...videoViewsCompleteConfig,
    tooltip: false,
    name: 'kpi.facebook.video_views_complete',
    id: 'video_views_complete',
    size: SIZE_FULL,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
